import {
  SetWriter as engagementOracleSetWriter,
  ResetUserTiers as engagementOracleResetUserTiers_,
  ChangeOwner as engagementOracleChangeOwner,
  AdminMethods as EngagementOracleAdminMethods,
} from './admin';
import {
  GetUserTier as engagementOracleGetUserTier,
  GetterMethods as EngagementOracleUserMethods,
} from './getters';
import {
  SetUserTier as engagementOracleSetUserTier,
  ResetUserTiers as engagementOracleResetUserTiers,
  SetterMethods as EngagementOracleWriterMethods,
} from './setters';

const NamedAdminMethods = {
  engagementOracleSetWriter,
  engagementOracleChangeOwner,
};
const NamedUserMethods = {
  engagementOracleGetUserTier,
};
const NamedWriterMethods = {
  engagementOracleSetUserTier,
  engagementOracleResetUserTiers,
};

export const EngagementOracleMethods = {
  ...NamedAdminMethods,
  ...NamedUserMethods,
  ...NamedWriterMethods,
};

export {
  EngagementOracleAdminMethods,
  EngagementOracleUserMethods,
  EngagementOracleWriterMethods,
};
export default EngagementOracleMethods;